export default __webpack_public_path__ + "static/O0119-10e850fbca1b96871d0162c9ff2fc1f6.png";